<span mat-dialog-title>{{ 'ACTIONS.SEND_SMS' | translate }}</span>

<mat-dialog-content>
  <mat-form-field>
    <mat-select
      id="sms-language-select"
      [placeholder]="'LANGUAGE.SELECT' | translate"
      [formControl]="langCodeControl"
    >
      @for (lang of smsLangs; track lang.code) {
        <mat-option [value]="lang.code">
          {{ lang.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <wlnob-sms
    [messageControl]="messageControl"
    (cancel)="dialogRef.close()"
    (send)="dialogRef.close($event)"
  >
  </wlnob-sms>
</mat-dialog-content>
